<div
  class="d-flex justify-content-center background-animation rounded"
  [style.height]="height"
>
  <div class="align-self-center">
    <isd-loading-spinner *ngIf="!hideSpinner"></isd-loading-spinner>
  </div>
</div>
